import { useMemo } from 'react';
import Head from 'next/head';
import { Collection } from '../snippets';
import { useSettings } from '@backpackjs/storefront';

export default function CollectionTemplate({
  collection,
  productsReady,
  renderSections,
}) {
  const settings = useSettings();
  const appEnabled = settings?.collection?.appEnabled;

  const products = appEnabled ? [] : collection?.products;

  const sections = renderSections();

  // determines if default collection heading should be shown
  const hasVisibleHeroSection = useMemo(() => {
    if (!sections?.length) return false;
    const HERO_KEYS = ['hero', 'collection-hero'];
    return sections.some(({ props }) => {
      return HERO_KEYS.includes(props?.['data-comp']) && !props?.hidden;
    });
  }, [sections]);

  // adding collection via section allows control of order of grid on the page
  // otherwise, collection is hardcoded after all sections
  const { sectionsBeforeCollection, sectionsAfterCollection } = useMemo(() => {
    if (!sections?.length) return {};
    const visibleCollectionIndex = sections.findIndex(({ props }) => {
      return props?.['data-comp'] === 'collection' && !props?.hidden;
    });
    const collectionPostitionIndex =
      visibleCollectionIndex >= 0 ? visibleCollectionIndex : sections.length;
    return {
      sectionsBeforeCollection: sections.slice(0, collectionPostitionIndex),
      sectionsAfterCollection: sections.slice(collectionPostitionIndex + 1),
    };
  }, [sections]);

  const heading = collection?.title;

  return (
    <>
      {heading && (
        <Head>
          <title>
            {heading && process.env.NEXT_PUBLIC_SITE_TITLE
              ? `${heading} | ${process.env.NEXT_PUBLIC_SITE_TITLE}`
              : (heading || process.env.NEXT_PUBLIC_SITE_TITLE || 'Rhoback')}
          </title>
        </Head>
      )}

      <div>
        {!hasVisibleHeroSection && (
          <div className="px-contained py-contained !pb-0">
            <div className="mx-auto flex max-w-[var(--content-max-xl-width)]">
              <h1 className="text-title-h2">{heading}</h1>
            </div>
          </div>
        )}
        
        {sectionsBeforeCollection || null}

        <div className="px-contained py-contained">
          <Collection
            handle={collection?.handle}
            id={collection?.id}
            appEnabled={appEnabled}
            products={products}
            productsReady={productsReady}
            title={heading}
          />
        </div>

        {sectionsAfterCollection || null}
      </div>
    </>
  );
}

CollectionTemplate.displayName = 'CollectionTemplate';
